import { computed, onBeforeMount, onBeforeUnmount, ref, unref, type MaybeRef } from 'vue'

type RelativeDatePosition = 'past' | 'now' | 'future' | 'unknown'

export function useRelativeDatePosition(date: MaybeRef<Date | string | null | undefined>) {
  const now = ref(new Date())

  const dateRelativity = computed<RelativeDatePosition>(() => {
    const dateVal = unref(date)

    if (dateVal === null || dateVal === undefined) return 'unknown'

    const normalizedDateVal = new Date(dateVal)

    if (normalizedDateVal > now.value) return 'future'
    if (normalizedDateVal < now.value) return 'past'
    return 'now'
  })

  let intervalId = null as number | null
  onBeforeMount(() => {
    if (intervalId !== null) clearInterval(intervalId)

    intervalId = setInterval(() => {
      now.value = new Date()
    }, 1000)
  })

  onBeforeUnmount(() => {
    if (intervalId !== null) clearInterval(intervalId)
    intervalId = null
  })

  return dateRelativity
}
